module.exports = __webpack_public_path__ + "img/home-2.60053b08.webp";